import 'ui-theme/components/issue-item/js/issue-item';

UX.issueItem.truncateOptions = {
    ...UX.issueItem.truncateOptions,
    lines: 2,
};
